<div [formGroup]="form" class="detail-right-column">
   <ng-container *ngIf="showCards; else generalInfoFields">
      <ndt-card [title]="'General Information'" class="detail-card-half">
         <ng-container *ngTemplateOutlet="generalInfoFields"></ng-container>
      </ndt-card>
   </ng-container>
   <ng-template #generalInfoFields>
      <mat-form-field class="flex-half">
         <mat-label>Extension Number</mat-label>
         <input
            matInput
            autocomplete="off"
            type="number"
            [value]="extension?.number"
            [formControl]="parentFormGroup.get('number')"
            required
            id="a548a982-17d2-4bee-9fa9-e2df166087e7"
         />
         <mat-error *ngIf="parentFormGroup.get('number')?.hasError('required')"> Number Field is Required. </mat-error>
         <mat-error *ngIf="parentFormGroup.get('number')?.hasError('pattern')"> Invalid Number Format </mat-error>
         <mat-error
            *ngIf="parentFormGroup.get('number')?.hasError('min') || parentFormGroup.get('number')?.hasError('max')"
         >
            Number must be between 100-99999.
         </mat-error>
         <mat-error *ngIf="parentFormGroup.get('number')?.hasError('extensionAlreadyExists')">
            Extension number already in use.
         </mat-error>
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.name"
            [formControl]="parentFormGroup.get('name')"
            required
            id="31ebd3f9-980e-4a68-b05d-0d3d768c2d4c"
         />
         <mat-error *ngIf="parentFormGroup.get('name')?.hasError('required')"> Name Field is Required. </mat-error>
         <mat-error
            *ngIf="
               !parentFormGroup.get('name')?.hasError('required') && parentFormGroup.get('name')?.hasError('noContent')
            "
         >
            Name must contain characters.
         </mat-error>
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Short Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.shortName"
            [formControl]="parentFormGroup.get('shortName')"
            id="fcbe6bcf-53ed-46e1-a709-41ad68109cb6"
         />
         <mat-error *ngIf="parentFormGroup.get('shortName')?.hasError('pattern')">
            Short Name cannot be greater than 20 characters.
         </mat-error>
      </mat-form-field>
   </ng-template>

   <ng-container *ngIf="showCards">
      <ndt-card [title]="'Notes'" class="detail-card-half">
         <ng-container *ngTemplateOutlet="notesFields"></ng-container>
      </ndt-card>
   </ng-container>
   <ng-template #notesFields>
      <mat-form-field class="flex-half" *ngIf="isSystemUser">
         <mat-label>Admin Notes</mat-label>
         <textarea
            matInput
            [formControl]="parentFormGroup.get('adminNotes')"
            id="extension-phone-dnd-status"
         ></textarea>
      </mat-form-field>
      <mat-form-field [ngClass]="{ 'flex-full': !isSystemUser, 'flex-half': isSystemUser }">
         <mat-label>Extension Notes</mat-label>
         <textarea
            matInput
            [formControl]="parentFormGroup.get('extensionNotes')"
            id="extension-phone-dnd-status"
            [readonly]="isSystemUser"
         ></textarea>
      </mat-form-field>
   </ng-template>

   <ng-container *ngIf="showCards; else settingFields">
      <ndt-card [title]="'Settings'" class="detail-card-half">
         <ng-container *ngTemplateOutlet="settingFields"></ng-container>
      </ndt-card>
   </ng-container>
   <ng-template #settingFields>
      <mat-form-field class="flex-full" *ngIf="accountId">
         <mat-label>Location</mat-label>
         <input
            autocomplete="off"
            type="text"
            [lcsSingleSelect]="locationSelect"
            ndtLocationSelect
            [accountId]="accountId"
            [formControl]="parentFormGroup.get('location')"
            id="location"
         />
         <ndt-location-select #locationSelect [isIncludeEmptyOption]="true"></ndt-location-select>
      </mat-form-field>
      <mat-form-field class="flex-full">
         <mat-label>Time Zone</mat-label>
         <input
            class="empty-option-placeholder"
            [lcsSingleSelect]="timeZoneSelect"
            ndtTimeZoneSelect
            autocomplete="off"
            type="text"
            [formControl]="parentFormGroup.get('timeZone')"
            id="extension-phone-time-zone"
            [placeholder]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         />
         <ndt-time-zone-select
            #timeZoneSelect
            [isIncludeEmptyOption]="true"
            [overrideEmptyOption]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         ></ndt-time-zone-select>
      </mat-form-field>
   </ng-template>

   <ng-container *ngIf="showCards; else timeoutFields">
      <ndt-card [title]="'Timeout Settings'" class="detail-card-half">
         <mat-checkbox
            *ngIf="showCards"
            class="card-header-checkbox mat-contrast"
            id="useTimeoutToggle"
            color="primary"
            header-action
            formControlName="useTimeoutToggle"
         >
            Use Timeout
         </mat-checkbox>
         <ng-container *ngTemplateOutlet="timeoutFields"></ng-container>
      </ndt-card>
   </ng-container>
   <ng-template #timeoutFields>
      <mat-checkbox
         class="flex-full"
         *ngIf="!showCards"
         id="useTimeoutToggle"
         color="primary"
         formControlName="useTimeoutToggle"
      >
         Use Timeout
      </mat-checkbox>
      <div class="flex-container flex-full">
         <mat-form-field class="flex-half">
            <mat-label>Timeout (seconds)</mat-label>
            <input
               matInput
               autocomplete="off"
               type="number"
               formControlName="timeoutSeconds"
               id="extension-auto-attendant-timeout-seconds"
            />
            <mat-error *ngIf="form.get('timeoutSeconds')?.hasError('required')"> Timeout Field is Required. </mat-error>
            <mat-error
               *ngIf="form.get('timeoutSeconds')?.hasError('min') || form.get('timeoutSeconds')?.hasError('max')"
            >
               Number must be between 1-10.
            </mat-error>
         </mat-form-field>
         <div class="flex-half"></div>
      </div>
      <div class="flex-container flex-full">
         <mat-form-field class="flex-half">
            <mat-label>Timeout Extension</mat-label>
            <input
               class="empty-option-placeholder"
               [lcsSingleSelect]="timeoutExtensionSelect"
               [accountId]="accountId"
               ndtExtensionSelect
               [extensionTypesToExclude]="[7]"
               autocomplete="off"
               type="text"
               formControlName="timeoutExtension"
               id="extension-auto-attendant-timeout-extension"
               [placeholder]="timeoutPlaceholder"
               [required]="this.form.get('useTimeoutToggle')?.value"
            />
            <ndt-extension-select #timeoutExtensionSelect [nullActionsToInclude]="nullActions"></ndt-extension-select>
            <mat-error *ngIf="form.get('timeoutExtension')?.hasError('required')">
               Timeout extension is required.
            </mat-error>
         </mat-form-field>
         <mat-radio-group
            formControlName="isTimeoutVoicemailOnly"
            class="flex-half"
            *ngIf="isTimeoutExtensionTypePhone; else placeholder"
         >
            <div class="radio-container">
               <mat-radio-button class="table-radio-button" [value]="false" color="primary">Extension</mat-radio-button>
               <mat-radio-button class="table-radio-button" [value]="true" color="primary">
                  Voicemail
               </mat-radio-button>
            </div>
         </mat-radio-group>
         <ng-template #placeholder>
            <div class="flex-half"></div>
         </ng-template>
      </div>
   </ng-template>
</div>
